import React from 'react';
export const Context = React.createContext(null);
export const langOptions = [
  {
    key: 'kaz',
    text: 'Қаз',
    value: 'kaz',
    flag: 'kz',
  },
  {
    key: 'rus',
    text: 'Рус',
    value: 'rus',
    flag: 'ru',
  },
];
